<template>
	<div
		ref="containerRef"
		class="relative size-full cursor-zoom-in"
		@dblclick="emitZoomEvent"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
const emits = defineEmits<{
	(event: 'zoomIn', cords: { x: number; y: number }): void;
}>();
const containerRef = ref<HTMLElement | null>(null);
function emitZoomEvent(event: MouseEvent) {
	const container = containerRef.value;
	const targetElement = event.target as HTMLElement;
	if (!container || !targetElement) return;

	const rect = targetElement.getBoundingClientRect();
	const mouseX = event.clientX - rect.left;
	const mouseY = event.clientY - rect.top;

	// Calcular a posição em porcentagem
	const percentageX = (mouseX / rect.width) * 100;
	const percentageY = (mouseY / rect.height) * 100;

	emits('zoomIn', {
		x: percentageX,
		y: percentageY
	});
}
</script>
